import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {VgAPI} from 'videogular2/core';
import {TourService} from '../services/tour.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Video} from '../model/video';

@Component({
  selector: 'gt-video-player-dialog',
  templateUrl: './video-player-dialog.component.html',
  styleUrls: ['./video-player-dialog.component.css']
})
export class VideoPlayerDialogComponent implements OnInit, OnDestroy {
  api: VgAPI;
  modalSources: Array<Object>;
  dialog: MatDialogRef<any>;
  video: Video;
  endedSubscription;

  constructor(private tourService: TourService,
              public dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) private data: any) {

    this.modalSources = [];
    this.dialog = dialogRef;
    this.video = data;
  }

  ngOnInit() {
    this.modalSources = this.tourService.getSourcesArrayForEncodings(this.video.encodings);
  }

  onPlayerReady(api: VgAPI) {
    this.api = api;
    this.endedSubscription = this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        // Set the video to the beginning
        this.api.getDefaultMedia().currentTime = 0;
      }
    );
  }

  ngOnDestroy() {
    this.endedSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/video-player-dialog.component.ts